module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#tick",
      toString: function () {
        return this.url;
      }
    }